import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/auth-provider';
import Dashboard from './dashboards/Dashboard';

const HomeRedirect = () => {
    const { loading, authenticated, isOperator } = useAuth();

    if (loading) return null;

    if (authenticated && isOperator && typeof isOperator === 'function' && isOperator()) {
        return <Navigate to="/mm-simple" replace />;
    }

    return <Dashboard />;
};

export default HomeRedirect;
